import React, { useState, useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { Astrolabe } from "../components/Astrolabe/Astrolabe";

const Home: React.FC = () => {
  const [showAstrolabe, setShowAstrolabe] = useState<boolean>(false);

  useEffect(() => {
    // Test API connection first
    const testAPI = async () => {
      try {
        const apiUrl =
          process.env.REACT_APP_API_URL || "http://localhost:8080/api/v1";
        const response = await fetch(`${apiUrl}/`);
        if (response.ok) {
          setShowAstrolabe(true);
        }
      } catch (error) {
        console.error("API connection failed:", error);
      }
    };

    testAPI();
  }, []);

  return (
    <div
      data-testid="home-container"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        margin: "0px auto 0px auto",
      }}
    >
      {showAstrolabe ? (
        // Outer clipping box — clips horizontally on mobile/tablet so ZodiacRing edges are hidden
        <Box
          sx={{
            width: "100%",
            overflow: "hidden",
          }}
        >
          {/* Inner box — wider than outer on mobile/tablet so ZodiacRing edges are clipped */}
          <Box
            sx={{
              width: { xs: "180%", md: "135%", lg: "100%" },
              maxWidth: { lg: 1250 },
              minWidth: { lg: 1250 },
              marginLeft: { xs: "-40%", md: "-17.5%", lg: 0 },
            }}
          >
            <Astrolabe
              rCelestials={160}
              rDays={200}
              rMonths={210}
              rSeasons={230}
              rZodiac={250}
              rEnd={280}
              rZodiacRingStart={300}
              rZodiacRingEnd={650}
              canvas={[1250, 1250]}
            />
          </Box>
        </Box>
      ) : (
        <CircularProgress aria-label="Loading astrolabe" />
      )}
    </div>
  );
};

export default Home;
